import { useEffect, useRef, useState } from 'react';
import styles from '../pages/SignupPage.module.css';
import { phoneCountryOptions } from '../utils/phoneCountryCodes';

/**
 * CountryCodeSelect
 *
 * Petit composant custom pour choisir un indicatif téléphonique.
 * - Dans la capsule : affiche uniquement le code (+32, +33, ...).
 * - Dans la liste déroulante : affiche le drapeau + pays + code.
 */
function CountryCodeSelect({ value, onChange, className = '' }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const selected =
    phoneCountryOptions.find((opt) => opt.dialCode === value) || phoneCountryOptions[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const handleSelect = (opt) => {
    if (onChange) {
      onChange(opt.dialCode);
    }
    setOpen(false);
  };

  return (
    <div className={styles.countryCodeWrapper} ref={wrapperRef}>
      <button
        type="button"
        className={`${styles.phoneCountrySelect} ${styles.countryCodeButton} ${className}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {selected.dialCode}
      </button>
      {open && (
        <div className={styles.countryCodeDropdown} role="listbox">
          {phoneCountryOptions.map((opt) => (
            <button
              type="button"
              key={`${opt.code}-${opt.dialCode}`}
              className={styles.countryCodeOption}
              onClick={() => handleSelect(opt)}
            >
              <span className={styles.countryCodeFlag}>{opt.flag}</span>
              <span className={styles.countryCodeLabel}>{opt.code}</span>
              <span className={styles.countryCodeDial}>{opt.dialCode}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default CountryCodeSelect;


